<template>
  <div>
    <nav id="nav-bar" class="navbar is-primary">
      <div class="navbar-brand">
        <router-link class="navbar-item" :to="{ name: 'Home'}">
          <i class="mdi mdi-home mdi-24px" />施工リスト管理
          <!-- ver.{{ version }} -->
        </router-link>
        <div class="navbar-burger burger" data-target="navMenu">
          <span />
          <span />
          <span />
        </div>
      </div>
      <div id="navMenu" class="navbar-menu">
        <div class="navbar-start">
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">施工主</a>
            <div class="navbar-dropdown">
              <router-link class="navbar-item" to="/companies">
                一覧
              </router-link>
              <router-link class="navbar-item" to="/companies/new/register">
                新規登録
              </router-link>
            </div>
          </div>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">通話履歴</a>
            <div class="navbar-dropdown">
              <router-link class="navbar-item" to="/call-histories">
                一覧
              </router-link>
            </div>
          </div>

          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">統計</a>
            <div class="navbar-dropdown">
              <router-link class="navbar-item" to="/call-calendars">
                通話件数カレンダー
              </router-link>
            </div>
          </div>
          
          <router-link class="navbar-item" to="/eight">
            Eight連携
          </router-link>
        </div>
        <div class="navbar-end">
          <div class="navbar-item">
            <p>ユーザー：{{ employeeName }}</p>
          </div>
          <div class="navbar-item" @click="logout">
            <button type="button" class="button is-small">
              <b-icon icon="logout" size="is-small" />
              <span>ログアウト</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
    <main class="section">
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      employeeName: null,
      version: null,
    }
  },
  mounted() {
    const burger = document.querySelector('.burger')
    const menu = document.querySelector('#' + burger.dataset.target)
    burger.addEventListener('click', function () {
      burger.classList.toggle('is-active')
      menu.classList.toggle('is-active')
    })
    this.employeeName = localStorage.employeeName
    this.version = process.env.VUE_APP_VERSION
  },
  methods: {
    logout() {
      this.$http.post('/logout').then(() => {
        localStorage.loggedIn = 0
        localStorage.employeeName = null
        this.$router.push({name: 'Login'})
      })
    },
  },
}
</script>
